export const mealplan = {
  half_board: {
    name: "Mezza pensione",
    icon: "restaurant",
    tooltip: '',
  },
  full_board: {
    name: "Pensione completa",
    icon: "restaurant",
    tooltip: '',
  },
  all_inclusive: {
    name: "All inclusive",
    icon: "drink",
    tooltip: '',
  },
  breakfast: {
    name: 'Colazione inclusa',
    icon: "breakfast",
    tooltip: '',
  },
  lunch: {
    name: "Pranzo incluso",
    icon: "cutlery",
    tooltip: '',
  },
  dinner: {
    name: "Cena inclusa",
    icon: "restaurant",
    tooltip: '',
  },
}

export function get_mealplan(key) {
  if (mealplan[key] !== undefined) return mealplan[key]

  return {
    name: key,
    icon: "breakfast",
  }
}